import { useQuery } from '@tanstack/react-query'
import axiosClient from '../../axios'
import type { MyCollaborator } from './myCollaborators'

export type MyTeamMember = MyCollaborator & { isMe: boolean }

export interface MyTeamResponse {
  success: boolean
  isCollaborator: boolean
  chef?: { contactName: string | null; email: string; companyName: string | null }
  members?: MyTeamMember[]
}

/**
 * For a collaborateur: their chef's identity + the chef's other
 * collaborateurs — the equivalent of "/my-collaborators" but seen from a
 * non-chef's side. `isCollaborator` is false (chef/members undefined) for
 * anyone who isn't themselves a collaborateur.
 */
export function useMyTeam(enabled = true) {
  return useQuery({
    queryKey: ['blot-analysis', 'my-team'],
    enabled,
    queryFn: async () => {
      const { data } = await axiosClient.get<MyTeamResponse>('/blot-analysis/my-team')
      return data
    },
    staleTime: 30_000,
  })
}
